import React from "react";
import { Navigate, useParams } from "react-router-dom";
import BillingScreen from "./BillingScreen";
import ProtectedRoute from "../components/ProtectedRoute";
import { getVoucherPageConfig, voucherPagePermissions } from "../config/voucherTransactionPages";

/**
 * /voucher/:slug — one screen per voucher type from sales import.
 */
export default function VoucherTransactionPage() {
  const { slug } = useParams();
  const config = getVoucherPageConfig(slug);

  if (!config) {
    return <Navigate to="/dashboard" replace />;
  }

  if (config.legacyScreen === "billing") {
    return <Navigate to="/billing" replace />;
  }

  return (
    <ProtectedRoute requirePermission={voucherPagePermissions(config)}>
      <BillingScreen voucherPageConfig={config} />
    </ProtectedRoute>
  );
}
